export const profileVisibility = {
  level: 'Standard',
  description: 'Standard',
  __typename: 'ProfileVisibility',
};

export const shareableProfileSettings = {
  profileSlug: 'fred-smith-sJT3vHkW7h',
  active: true,
  views: 321,
  url: 'https://www.seek.com.au/profile/fred-smith-sJT3vHkW7h',
  displayUrl: 'seek.com.au/profile/fred-smith-sJT3vHkW7h',
};

export const approachability = {
  __typename: 'Approachability',
  approachable: true,
};
